import icon from './social_reach.png.js';
import template from './graph_widget_view.html';
import templateMaxView from './social_reach_graph_widget_max.html';
import templateReportView from './social_reach_graph_widget_report.html';

function stripContentFilter(scope) {
    //This function strips content filter from existing social reach widgets
    //where the content filter is incorrectly applied
    //See ticket NLZ-595
    //DO NOT USE ME IN FUTURE WIDGETS!!!!
    if(scope.widget.filters['Content']) {
        delete scope.widget.filters['Content'];
    }
}

angular
    .module('MW.InsDashboard.SocialReachWidget',[
        'MW.InsDashboard.insightsBackendService',
        'MW.Dashboard.DashboardWidgetService',
        'DashboardChartConfigService',
        'CoreChartObject',
        'MW.Framework.TranslationService',
        'MW.Framework.GeoService',
        'MW.InsDashboard.InsWidgetConfigService',
        'MW.Framework.CoreCommon',
        'MW.InsDashboard.ChartDataService',
        'MW.InsDashboard.InsightsDataMaps',
        'MW.InsDashboard.TransformSentiment',
        'MW.Framework.CoreBreadcrumb',
        'MW.Dashboard.DashboardStateService',
        'MW.Framework.AppChromeService',
        'MW.InsDashboard.SocialReachService',
        'MW.Framework.CoreUserService',
        'MW.Configuration',
        'MW.InsDashboard.SocialReachWidget.BarChartDataFormatter',
        'MW.InsDashboard.SocialReachWidget.GroupedBarChartDataFormatter'
    ])
    .directive('socialReachWidget', [
        'insightsBackendService',
        'DashboardWidgetService',
        '$filter',
        'DashboardChartConfigService',
        'CoreChartObject',
        'translationService',
        'GeoService',
        'InsWidgetConfigService',
        'CoreCommon',
        'ChartDataService',
        'InsightsDataMaps',
        'TransformSentiment',
        '$routeParams',
        '$location',
        'Breadcrumb',
        'DashboardStateService',
        'SocialReachService',
        'CoreUserService',
        'BarChartDataFormatter',
        'GroupedBarChartDataFormatter',
        function(
            insightsBackendService,
            DashboardWidgetService,
            $filter,
            DashboardChartConfigService,
            CoreChartObject,
            translationService,
            GeoService,
            InsWidgetConfigService,
            CoreCommon,
            ChartDataService,
            InsightsDataMaps,
            TransformSentiment,
            $routeParams,
            $location,
            Breadcrumb,
            DashboardStateService,
            SocialReachService,
            CoreUserService,
            BarChartDataFormatter,
            GroupedBarChartDataFormatter
        ) {

            var socialReachWidget = DashboardWidgetService.getWidget('social-reach-widget');

            socialReachWidget.editViewFile = 'graph_widget_view';
            socialReachWidget.userViewFile = 'graph_widget_view';
            socialReachWidget.maximizedViewFile = 'social_reach_graph_widget_max';
            socialReachWidget.reportViewFile = 'social_reach_graph_widget_report';

            var socialReachWidgetController = function ($scope) {
                $scope.insightsService = 'statisticService';
                $scope.insightsObject = 'dateSentimentHistograms';
                $scope.initSettings = function () {
                    InsWidgetConfigService.readyWidgetData($scope);
                };
            };

            var socialReachWidgetLink = function (scope, element) {

                var getLabelFormatFromSettings = function getLabelFormatFromSettings() {
                    return CoreCommon.isUsable(scope.widget.settings.labelFormat) ? scope.widget.settings.labelFormat[0].id : scope.widget.availableLabelFormat[0].id;
                };

                var getDateBreakoutsFromSettings = function getDateBreakoutsFromSettings() {
                    return CoreCommon.isUsable(scope.widget.settings.dateBreakouts) ? scope.widget.settings.dateBreakouts[0].id : scope.widget.availableDateBreakouts[0].id;
                };

                scope.widget.settings.chart = {
                    xAxisType: 'category',
                    yAxisAbs: true
                };

                var getLabelVisibilityFromSettings = function getLabelVisibilityFromSettings() {
                    return CoreCommon.isUsable(scope.widget.settings.labelVisibility) ? scope.widget.settings.labelVisibility[0].id : scope.widget.availableLabelVisibility[0].id;
                };
                scope.labelVisibility = (getLabelVisibilityFromSettings() == 1) ? false : true;

                scope.selectedLabelFormatId = getLabelFormatFromSettings(); // Getting Label Format id from widget.settings

                if (scope.selectedLabelFormatId == 1) { // Number
                    scope.widget.settings.chart.percentageMode = false;
                } else if (scope.selectedLabelFormatId == 2) { // Percentage
                    scope.widget.settings.chart.percentageMode = true;
                }

                scope.selectedDateBreakoutsId = getDateBreakoutsFromSettings(); // Getting Date Breakouts Id from widget.settings

                var quarterBreakoutOption = scope.widget.availableDateBreakouts.find(function (element) {
                    return element.id == 'QUARTER';
                });
                var quarterBreakoutIndex = scope.widget.availableDateBreakouts.indexOf(quarterBreakoutOption);

                if (quarterBreakoutIndex > -1) {
                    scope.widget.availableDateBreakouts.splice(quarterBreakoutIndex, 1);
                }

                var yearBreakoutOption = scope.widget.availableDateBreakouts.find(function (element) {
                    return element.id == 'YEAR';
                });
                var yearBreakoutIndex = scope.widget.availableDateBreakouts.indexOf(yearBreakoutOption);

                if (yearBreakoutIndex > -1) {
                    scope.widget.availableDateBreakouts.splice(yearBreakoutIndex, 1);
                }

                scope.dateBreakoutsDay = (scope.selectedDateBreakoutsId === 'DAY');
                scope.dateBreakoutsWeek = (scope.selectedDateBreakoutsId === 'WEEK');
                scope.dateBreakoutsMonth = (scope.selectedDateBreakoutsId === 'MONTH');

                scope.widgetIsLoading = false;
                scope.noDataFromServer = false;
                scope.notConfigured = false;
                scope.serviceError = false;
                scope.fetching = false;
                scope.showTable = false;
                scope.documentRequest = {};

                scope.graphType = CoreCommon.isUsable(scope.widget.settings.selectedGraphType) ? scope.widget.settings.selectedGraphType.id : scope.widget.getDefaultChartType().id;

                // Run our updating function when we recieve an update notification from a widget higher in the scope tree.
                scope.$on('widgetFiltersUpdated', function () {
                    scope.fetchData(true);
                });

                scope.fetchData = function (isExternal) {
                    isExternal = isExternal || false;
                    scope.initSettings();
                    if (!scope.readyToQuery)
                        return;

                    if (isExternal) {
                        scope.graphType = scope.widget.settings.selectedGraphType.id || scope.graphType;
                        if (scope.graphType != 'table') {
                            scope.highchart = true;
                        }
                    }

                    scope.widgetIsLoading = true;
                    scope.serviceError = false;
                    scope.noDataFromServer = false;
                    scope.notConfigured = false;

                    scope.chartDataObject.dataMap = InsightsDataMaps.datamapDateSentiment;
                    scope.chartDataObject.percent = scope.widget.settings.chart.percentageMode;
                    scope.chartDataObject.chartTransformFunction = TransformSentiment[scope.graphType];

                    //URL sharing on widgets for correct chart
                    scope.chartDataObject.queryParameters.dateStart = scope.chartDataObject.fromDate;
                    scope.chartDataObject.queryParameters.dateEnd = scope.chartDataObject.toDate;

                    // See comment in function
                    stripContentFilter(scope);

                    var dateEnd = scope.chartDataObject.queryParameters.dateEnd,
                        dateStart = scope.chartDataObject.queryParameters.dateStart,
                        filters = scope.widget.filters,
                        granularity = scope.chartDataObject.queryParameters.granularity,
                        searchId = scope.chartDataObject.inputs[0].id,
                        timezone = CoreUserService.getTimezone();

                    SocialReachService.getSocialReach(searchId, dateStart, dateEnd, granularity, timezone, filters).then(function (socialReachData) {
                        if(scope.graphType === 'column') {
                           scope.chartData = BarChartDataFormatter.formatChartData(scope, socialReachData, dateStart, dateEnd, granularity);
                        } else {
                            scope.chartData = GroupedBarChartDataFormatter.formatChartData(scope, socialReachData, dateStart, dateEnd, granularity);
                        }
                        scope.widgetIsLoading = false;
                    });
                };

               scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
                    var newParams = getRequestparams(newVal),
                        oldParams = getRequestparams(oldVal),
                        breadcrumbString,
                        breadcrumbArray,
                        displayDate;

                    if (newParams.date) {
                        //correctly parsing the '+' character in encoded date in newParams
                        newParams.date = newParams.date.replace(/(%2B)/g, '+');
                    }

                    updateBreadcrumb(newParams.date);

                    if (typeof scope.inputs !== 'undefined') {
                        scope.drillDown(scope.inputs[0].id, newParams.date, scope);
                    } else {
                        scope.drillDown(scope.searches[0].agent, newParams.date, scope);
                    }

                    if (newVal.indexOf('&drilled&') > -1) {
                        if (newParams.date) {
                            displayDate = moment(newParams.date.split('T')[0]);
                            breadcrumbString = scope.breadcrumbs[scope.breadcrumbs.length - 1].name;
                            breadcrumbArray = breadcrumbString.split(',');
                            if (scope.dateBreakoutsMonth) {
                                updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.format("MMM") + ' ' + displayDate.year());
                            }
                        }
                    }
                });

                if (scope.widget.hasRequiredSettings()) {
                    scope.fetchData();
                }
                else scope.notConfigured = true;

                scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
                    var newParams = getRequestparams(newVal),
                        oldParams = getRequestparams(oldVal),
                        breadcrumbString,
                        breadcrumbArray,
                        displayDate;

                    if (newParams.date) {
                        //correctly parsing the '+' character in encoded date in newParams
                        newParams.date = newParams.date.replace(/(%2B)/g, '+');
                    }

                    updateBreadcrumb(newParams.date);

                    if (typeof scope.inputs !== 'undefined') {
                        scope.drillDown(scope.inputs[0].id, newParams.date, scope);
                    } else {
                        scope.drillDown(scope.searches[0].agent, newParams.date, scope);
                    }

                    if (newVal.indexOf('&drilled&') > -1) {
                        if (newParams.date) {
                            displayDate = moment(newParams.date.split('T')[0]);
                            breadcrumbString = scope.breadcrumbs[scope.breadcrumbs.length - 1].name;
                            breadcrumbArray = breadcrumbString.split(',');
                            if (scope.dateBreakoutsMonth) {
                                updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.format("MMM") + ' ' + displayDate.year());
                            }
                        }
                    }
                });

                var updateLastBreadcrumb = function updateLastBreadcrumb(lastBreadcrumb) {
                    scope.breadcrumbs[scope.breadcrumbs.length - 1].name = lastBreadcrumb;
                };

                var getRequestparams = function getRequestparams(url) {
                    var params = {};
                    var searchStr = url.split("?")[1];
                    if (searchStr !== undefined) {
                        var paramsStr = searchStr.split("&");
                        for (var key in paramsStr) {
                            params[paramsStr[key].split("=")[0]] = paramsStr[key].split("=")[1];
                        }
                    }
                    return params;
                };

                scope.internalDrillDown = function (id, date) {
                    if (scope.isMaximized) {
                        var queryParams = {
                            drilled: true
                        };
                        if (date) {
                            queryParams['date'] = $filter('mwConvertDateToUserTimezone')(date);
                        }
                        updateLocationURL(queryParams);
                    }
                    scope.drillDown(id, date, scope);
                    if (scope.graphType !== 'table') {
                        scope.$apply();
                        delete scope.documentRequest.source;
                        delete scope.chartDataObject.queryParameters.source;
                    }
                };

                var updateLocationURL = function updateLocationURL(queryParams) {
                    var maxPath,
                        editMode = $routeParams.editMode || false;
                    if ($location.path().indexOf('/dashboard/index') === 0) {
                        maxPath = '/dashboard/viewer/' + DashboardStateService.getDefaultDashboard() + '/' + scope.widget.id;
                    } else if ($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new') {
                        maxPath = $location.path();
                    } else {
                        maxPath = '/dashboard/' + ($location.path().indexOf('builder') === -1 ? 'viewer' : 'builder') + '/' + (DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
                    }

                    if (!$routeParams.drilled) {
                        queryParams['drilled'] = true;
                    }

                    var urlQuery = {
                        editMode: editMode
                    };
                    for (var prop in queryParams) {
                        urlQuery[prop] = queryParams[prop]
                    }
                    updateBreadcrumb(queryParams.date);
                    $location.path(maxPath).search(urlQuery);
                };

                var updateBreadcrumb = function updateBreadcrumb(date) {
                    var dashboardPath,
                        widgetPath,
                        selectionTitle = '',
                        dashboardMode = $location.path().indexOf('/dashboard/viewer') !== -1 ? '/dashboard/viewer/' : '/dashboard/builder/';

                    scope.breadcrumbs = [];
                    scope.breadcrumbs = [Breadcrumb.build({
                        name: 'Analyze',
                        link: '/analyze/home',
                        isClickable: false
                    })];
                    dashboardPath = '/dashboard/viewer/' + scope.dashboard._id;
                    scope.breadcrumbs.push(Breadcrumb.build({name: scope.dashboard.title, link: dashboardPath}));

                    //capitalizing the first letter
                    if (scope.documentRequest.source) {
                        selectionTitle += scope.documentRequest.source.charAt(0).toUpperCase() + scope.documentRequest.source.slice(1);
                    }
                    selectionTitle += date ? ', ' + $filter('mwConvertDateToUserTimezone')(date, 'MMM Do') : '';

                    if (selectionTitle === '') {
                        var mypath = '/dashboard/viewer/' + scope.dashboard._id,
                            subCrumbs = [],
                            myNewPath,
                            subCrumbVal;

                        if (scope.dashboard.containers[0].widgets.length > 1) {
                            Object.keys(scope.dashboard.containers[0].widgets).forEach(function (key) {
                                myNewPath = dashboardMode + scope.dashboard._id + '/' + scope.dashboard.containers[0].widgets[key].id + '?editMode=false';
                                subCrumbVal = {
                                    name: scope.dashboard.containers[0].widgets[key].title,
                                    link: myNewPath,
                                    isClickable: function isClickable() {
                                        return true;
                                    }
                                };

                                subCrumbs.push(subCrumbVal);
                            });
                        }
                        scope.breadcrumbs.push(Breadcrumb.build({name: scope.widget.title, subCrumbs: subCrumbs}));
                    } else {
                        widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                        scope.breadcrumbs.push(Breadcrumb.build({name: scope.widget.title, link: widgetPath}));
                        scope.breadcrumbs.push(Breadcrumb.build({name: selectionTitle}));
                    }
                };

                scope.drillDown = InsWidgetConfigService.dateGranularityDrilldown;

                scope.togglePercentage = function (id) {
                    var oldMode = scope.widget.settings.chart.percentageMode,
                        mode;
                    scope.selectedLabelFormatId = id;
                    if (id === 1) {
                        mode = false;
                    } else if (id === 2) {
                        mode = true;
                    }
                    scope.widget.settings.chart.percentageMode = mode;
                    if (oldMode !== scope.widget.settings.chart.percentageMode)
                        scope.fetchData();
                };

                scope.toggleGraph = function (graphType) {
                    InsWidgetConfigService.queryRequestSettings.dateStart = scope.chartDataObject.fromDate;
                    InsWidgetConfigService.queryRequestSettings.dateEnd = scope.chartDataObject.toDate;
                    var oldGraphType = scope.graphType;
                    scope.graphType = graphType;
                    scope.showTable = false;

                    resetBreadcrumb()
                    scope.fetchData();
                    scope.initSettings();
                };

                scope.toggleTable = function () {
                    InsWidgetConfigService.queryRequestSettings.dateStart = scope.chartDataObject.fromDate;
                    InsWidgetConfigService.queryRequestSettings.dateEnd = scope.chartDataObject.toDate;
                    scope.graphType = 'table';
                    resetBreadcrumb();
                    scope.fetchData();
                };

                var resetBreadcrumb = function resetBreadcrumb() {
                    var maxPath,
                        editMode = $routeParams.editMode || false;
                    if ($location.path().indexOf('/dashboard/index') === 0) {
                        maxPath = '/dashboard/viewer/' + DashboardStateService.getDefaultDashboard() + '/' + scope.widget.id;
                    } else if ($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new') {
                        maxPath = $location.path();
                    } else {
                        maxPath = '/dashboard/' + ($location.path().indexOf('builder') === -1 ? 'viewer' : 'builder') + '/' + (DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
                    }

                    var urlQuery = {
                        editMode: editMode
                    };

                    updateBreadcrumb();
                    $location.path(maxPath).search(urlQuery);
                };

                scope.tableSettings = {
                    enabled: true,
                    data: {},
                    rowTitle: translationService.getLocalizedString('Sentiment'),
                    summaryTitle: translationService.getLocalizedString('Total'),
                    countField: 'sentimentCount',
                    percentField: 'sentimentPercent',
                    titleField: 'name'
                };
            };

            return new WidgetDirective(socialReachWidget, socialReachWidgetLink, socialReachWidgetController);
        }]
    )
.run(['DashboardWidgetService', 'translationService', 'CoreCommon', 'InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', 'SocialReachChartScale', function (DashboardWidgetService, translationService, CoreCommon, InsWidgetConfigService, DASHBOARD_LEGACY_URL, SocialReachChartScale) {
    DashboardWidgetService.register({
        name: translationService.getLocalizedString('social-reach-widget__add-widget--title'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('social-reach-widget__add-widget--description'),
        directive: 'social-reach-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            source: [],
            'maxAgents': 1
        },
        displayOrder: 3,
        allowExport: true,
        availableFilters : [{name:'Country',id:'country'},{name:'Language',id:'language'},{name:'Sentiment',id:'sentiment'}],
        availableSettings: ['dateRange', 'title', 'social', 'labelFormat', 'dateBreakouts', 'labelVisibility', 'chartType', 'chartScale'],
        availableChartScales: [
            // Names are translated in node-translations
            {
                name: 'social-reach-widget__chart-scale-option--scaled',
                id: SocialReachChartScale.SCALED
            },
            {
                name: 'social-reach-widget__chart-scale-option--standard',
                id: SocialReachChartScale.STANDARD
            }
        ],
        availableChartTypes:[
            {name:'Bar',id:'column'},
            {name:'Grouped Bars',id:'groupedColumn'}
        ],
        requiredSettings: ['dateRange'],
        getChartScaleProperty: function getChartScaleProperty () {
            if(this.settings.chartScale &&
                Array.isArray(this.settings.chartScale) &&
                this.settings.chartScale.length > 0 &&
                this.settings.chartScale[0].id) {

                return this.settings.chartScale[0].id;
            }
            else {
                return this.getDefaultChartScaleId();
            }

        },
        getDefaultChartScaleId: function() {
            return SocialReachChartScale.SCALED;
        },
        getDefaultChartType: function() {
            return this.availableChartTypes[1];
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });
}]);
